import type { RootState, SetState } from '../../useStore';

export type DeviceDirection = 'left' | 'right' | 'portrait';

export type SafeZone = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export type DeviceOrientationInfo = {
  direction?: DeviceDirection;
  safeZone?: SafeZone;
};

export type DeviceSafeZoneSliceProps = {
  deviceSafeZone: {
    direction: DeviceDirection | null;
    safeZone: SafeZone | null;
    setDeviceOrientationInfo: (info: DeviceOrientationInfo) => void;
  };
};

// In landscape the camera cutout sits on the side reported by `direction`
// ('left'|'right'); 'portrait' (or missing data) means there is no side to avoid.
export const getCameraSide = (
  direction: DeviceDirection | null,
): 'left' | 'right' | null =>
  direction === 'left' || direction === 'right' ? direction : null;

export const deviceSafeZoneSlice = ({
  set,
}: SetState<RootState>): DeviceSafeZoneSliceProps => ({
  deviceSafeZone: {
    direction: null,
    safeZone: null,
    setDeviceOrientationInfo: ({ direction, safeZone } = {}) =>
      set(
        (state: RootState) => ({
          ...state,
          deviceSafeZone: {
            ...state.deviceSafeZone,
            direction: direction ?? null,
            safeZone: safeZone ?? null,
          },
        }),
        undefined,
        'deviceSafeZone/setDeviceOrientationInfo',
      ),
  },
});
